import { z } from "zod";
const DECIMAL_ID_PATTERN = /^[0-9]+$/;
export const apiIntIdSchema = z.number().int().positive();
export const apiBigIntIdSchema = z
    .string()
    .regex(DECIMAL_ID_PATTERN, "must be a decimal identifier string");
export function isApiBigIntId(value) {
    return typeof value === "string" && DECIMAL_ID_PATTERN.test(value);
}
/** Database record -> HTTP DTO. */
export function toApiBigIntId(value) {
    if (value < 0n) {
        throw new RangeError("Identifiers are non-negative");
    }
    return value.toString(10);
}
export function toApiBigIntIdOrNull(value) {
    return value === null || value === undefined ? null : toApiBigIntId(value);
}
/**
 * HTTP DTO -> database value. Only for values that already passed schema
 * validation on a trusted server-side path.
 */
export function fromApiBigIntId(value) {
    if (!DECIMAL_ID_PATTERN.test(value)) {
        throw new TypeError("Identifier must contain decimal digits only");
    }
    return BigInt(value);
}
export function fromApiBigIntIdOrNull(value) {
    return value === null || value === undefined ? null : fromApiBigIntId(value);
}
/**
 * `AuditLog.entityId` is polymorphic: it may point at an `Int` or a `BigInt`
 * entity, so it is stored as the decimal representation of either.
 */
export function toAuditEntityId(value) {
    return typeof value === "string" ? value : value.toString(10);
}
//# sourceMappingURL=ids.js.map